<div class="provider-actions">
    <a *ngIf="canDo('Proveedores','Editar')" [routerLink]="['/provider/update', providerId]"
        [queryParams]="{ name: providerName }" title="Editar proveedor">
        <img src="assets/img/provider/icon-edit.svg" alt="Editar" width="24" height="24">
    </a>
    <a *ngIf="canDo('Proveedores','Ver')" [routerLink]="['/provider/view', providerId]"
        [queryParams]="{ name: providerName }" title="Ver proveedor">
        <img src="assets/img/provider/icon-view.svg" alt="Ver" width="24" height="17">
    </a>
</div>
